import React, { Component } from "react";
import { observer, inject } from "mobx-react";

import { Button, Glyphicon } from "react-bootstrap";
import CustomerList from "../Components/CustomersList";
import ButtonBack from "../Components/ButtonBack";
import SearchInput from "../Components/SearchInput";

class CustomersListPage extends Component {

    onAddClicked() {
        const { stores } = this.props;

        let newCustomer = stores.data.CustomersStore.add();

        const hash = `#customer-detail?id=` + newCustomer.Id;
        window.location.hash = hash;
    }

    render() {
        const { stores } = this.props;
        const { search } = stores.ui.view.parameters;

        return (
            <div>
                <div className="row">
                    <ButtonBack />
                </div>

                <div className="row">
                    <h1>Customers</h1>
                </div>

                <div className="row">
                    <div className="pull-left">
                        <SearchInput />
                    </div>
                    <div className="pull-right">
                        <Button
                            type="button"
                            bsStyle="success"
                            onClick={this.onAddClicked.bind(this)}
                        >
                            <Glyphicon glyph="plus" />
                            <span>Add</span>
                        </Button>
                    </div>
                </div>

                <div className="row">
                    <CustomerList customersStore={stores.data.CustomersStore} filter={search} />
                </div>
            </div>
        );
    }
}

export default inject("stores")(observer(CustomersListPage));



// WEBPACK FOOTER //
// ./src/Pages/CustomersListPage.js